var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"extra-price"},[_vm._v("\n  "+_vm._s(_vm.paymentScheme === 'supplier' && _vm.currency !== 'USD'
      ? _vm.$t(`${_vm.base}.price_supplier`, {
          amount: _vm.amount.format(true),
          currency: _vm.currency,
          usd: _vm.amountUsdCurrency.format(true),
        })
      : _vm.$t(`${_vm.base}.price`, {
          amount: _vm.amount.format(true),
          currency: _vm.currency,
        }))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }